import { Injectable } from '@angular/core';
import { Projects } from '../project.service/ProjectCover';
import { PaperTags } from './PaperTags';
import { Publication } from './publication';

@Injectable({providedIn: 'root'})
export class publicationsService {
    constructor() { }


    get_all_publication():Publication[]{
        let publications = []

        let wp0_jmp = new Publication()
        wp0_jmp.title="Cash Transfer at Birth Reduces Criminal Activity of Fathers and Children";
        wp0_jmp.abstract="This paper examines the impact of additional income provided to low-income families immediately after childbirth on criminal justice involvement. Using a regression discontinuity design, I exploit a policy that allows children born before year-end to be claimed as dependents for that tax year, thereby providing additional cash during the first year of parenthood. Using linked administrative data, I find that this extra income immediately reduces the likelihood of criminal charges and incarceration among first-time fathers, particularly for income-related offenses. In the long run, it also reduces juvenile justice involvement among their children."
        wp0_jmp.arxiv_link="../../../assets/publications/Bhardwaj_Sakshi_JMP.pdf";
        // wp1.doi="";
        // wp0_jmp.year=2023;
        wp0_jmp.authors_list= ["Sakshi Bhardwaj"];
        // wp0_jmp.bibtex=''
        // seams2022.conference_name="17th Symposium on Software Engineering for Adaptive and Self-Managing Systems 2022",
        // seams2022.tags=[PaperTags.Human_Drone_Interaction, PaperTags.Visualization, PaperTags.Autonomous_Drone]
        wp0_jmp.type="Published and Accepted Papers"
        // wp0_jmp.ppt="",
        // seams2022.conference_url="https://conf.researchr.org/home/seams-2022"
        // seams2022.has_award=false;
        // seams2022.award_name="";
        // seams2022.proj_id=Projects.Human_Drone
        wp0_jmp.isPublished=true;
        wp0_jmp.current_status="Accepted, Journal of Public Economics"
        publications.push(wp0_jmp);
        
            

         

            let wip1 = new Publication()
            wip1.title="Welfare programs, eligibility tightening, and financial distress: Evidence from Indiana Welfare Automation";
            wip1.abstract="Towards modernizing its welfare system, the state awarded IBM a $1.3 billion contract in 2006, in order to automate the application process for TANF, food stamps, and Medicaid. The automation was designed to reduce fraud, decrease spending, and move clients off welfare rolls. The automation was conducted in three waves before the program was discontinued and canceled in 2010. Initially, 12 counties were affected, followed by 27 and 20 counties in subsequent waves. The paper used the financial information from a large, nationally-representative longitudinal sample of one of the three major consumer credit reporting agencies that cover a random sample of 1% of the US population. Exploiting the quasi-random policy rollout, we causally identify the impact of the Indiana welfare automation by comparing the outcomes over time between the treated counties and the control counties. We find that the Indiana welfare automation program, which reduced enrollment in SNAP, TANF, and Medicaid, significantly increased the number of accounts in collections, the number of medical collections, the medical balance in collections, and the number of bankruptcy filings. The paper shows that inefficient welfare automation can negatively impact financial wellbeing and lead to increased debt."
            wip1.arxiv_link="../../../assets/publications/Paper_Indiana.pdf";
            // wip1.doi="";
            // wip1.year=2022;
            wip1.authors_list= ["Sakshi Bhardwaj","Daniel Rodrigues Silva Tabak"];
            // seams2022.bibtex='@inproceedings{ClelandHuang2022ExtendingMT,\
            //   title={Extending MAPE-K to support Human-Machine Teaming},\
            //   author={Jane Cleland-Huang and Ankit Agrawal and Michael Vierhauser and Michael Murphy and Mike Prieto},\
            //   year={2022}\
            // }'
            // seams2022.conference_name="17th Symposium on Software Engineering for Adaptive and Self-Managing Systems 2022",
            // seams2022.tags=[PaperTags.Human_Drone_Interaction, PaperTags.Visualization, PaperTags.Autonomous_Drone]
            wip1.type="Working Papers"
            wip1.ppt="../../../assets/presentations/Slides_Indiana.pdf",
            // seams2022.conference_url="https://conf.researchr.org/home/seams-2022"
            // seams2022.has_award=false;
            // seams2022.award_name="";
            // seams2022.proj_id=Projects.Human_Drone
            wip1.isPublished=false;
            publications.push(wip1);

        let published_3 = new Publication()
            published_3.title="Can Earned Income Tax Credit Affect the Labor Supply of Undocumented Immigrants";
            published_3.abstract="This paper examines the labor market effects of eliminating the Earned Income Tax Credit (EITC) for undocumented immigrants by requiring a Social Security number to claim the credit. Using data from the Survey of Income and Program Participation (SIPP) and comparing likely undocumented immigrants with natives, I find a significant decrease in the likelihood of undocumented immigrants receiving the EITC following the 1996 policy change. Leveraging Current Population Survey (CPS) data, I exploit variations in whether undocumented single mothers havechildren, the timing of the policy, and a placebo group of undocumented married men. The results show that the termination of the EITC led to a 6–9 percentage point reduction in the extensive-margin labor supply of undocumented single mothers. These findings highlight the double disadvantage faced by the children of undocumented single mothers, who are predominantly U.S. citizens in low-income households. Not only are they excluded from the benefits of the tax credit, but their  mothers’ labor supply and overall family income are also adversely affected."

            published_3.arxiv_link= "../../../assets/publications/Can-Earned-Income-Tax-Credit-Affect-the-Labor-Supply-of-Undocumented-Immigrants.pdf";
            // wp2.doi="";
            // wp2.year=2022;
            published_3.authors_list= ["Sakshi Bhardwaj"];
            // seams2022.bibtex='@inproceedings{ClelandHuang2022ExtendingMT,\
            //   title={Extending MAPE-K to support Human-Machine Teaming},\
            //   author={Jane Cleland-Huang and Ankit Agrawal and Michael Vierhauser and Michael Murphy and Mike Prieto},\
            //   year={2022}\
            // }'
            // seams2022.conference_name="17th Symposium on Software Engineering for Adaptive and Self-Managing Systems 2022",
            // seams2022.tags=[PaperTags.Human_Drone_Interaction, PaperTags.Visualization, PaperTags.Autonomous_Drone]
            published_3.type="Published and Accepted Papers"
            // wp2.ppt="",
            published_3.conference_url="https://www.emerald.com/books/edited-volume/21438/chapter-abstract/112955039/Can-Earned-Income-Tax-Credit-Affect-the-Labor?redirectedFrom=fulltext"
            // seams2022.has_award=false;
            // seams2022.award_name="";
            // seams2022.proj_id=Projects.Human_Drone
            
            published_3.isPublished=true;
            published_3.current_status="Research in Labor Economics, 2026"
            publications.push(published_3);

         



            let published_2 = new Publication()
            published_2.title="The Impact of Cash after Childbirth on Crime: Evidence from a Discontinuity in Tax Benefits";
            published_2.abstract="This paper examines the causal impact of additional income provided to low-income families shortly after childbirth on mothers' criminal justice involvement. Using a regression discontinuity design based on year-end births, where children born before December 31 generate larger cash transfers in the form of refundable tax credits for families compared to January-born children, I analyze linked administrative data from a large US metropolitan county. I find that eligibility for additional income during the first year of childbirth does not significantly impact mothers' criminal activity in the immediate years following childbirth but significantly reduces long-term criminal justice involvement among mothers."
            
            published_2.arxiv_link="https://www.aeaweb.org/articles?id=10.1257/pandp.20251128";
            // wp2.doi="";
            // wp2.year=2022;
            published_2.authors_list= ["Sakshi Bhardwaj"];
            // seams2022.bibtex='@inproceedings{ClelandHuang2022ExtendingMT,\
            //   title={Extending MAPE-K to support Human-Machine Teaming},\
            //   author={Jane Cleland-Huang and Ankit Agrawal and Michael Vierhauser and Michael Murphy and Mike Prieto},\
            //   year={2022}\
            // }'
            // seams2022.conference_name="17th Symposium on Software Engineering for Adaptive and Self-Managing Systems 2022",
            // seams2022.tags=[PaperTags.Human_Drone_Interaction, PaperTags.Visualization, PaperTags.Autonomous_Drone]
            published_2.type="Published and Accepted Papers"
            // wp2.ppt="",
            published_2.conference_url="https://www.aeaweb.org/articles?id=10.1257/pandp.20251128"
            // seams2022.has_award=false;
            // seams2022.award_name="";
            // seams2022.proj_id=Projects.Human_Drone
            published_2.isPublished=true;
            published_2.current_status="AEA Papers and Proceedings, 2025"
            publications.push(published_2);


            let published_1 = new Publication()
            published_1.title="Social identity and learning: Adult literacy program in India";
            published_1.abstract="The paper examines the effect of \
            social identity on adult learning within a \
            hierarchical social setting— an important yet often\
            understudied issue for effective adult education.\
            We leverage the random matching of students and\
            teachers from a randomized controlled experiment in India, \
            where illiterate adult female learners aged 18–45 were randomly\
            assigned to a literacy program. We find a positive and \
            significant impact of matching an upper caste teacher with a\
             lower caste adult student on literacy scores. \
             We also find suggestive evidence of an increase \
             in students' confidence measures when matched with an upper caste teacher, \
             indicating a plausible impact mechanism. Our findings \
             highlight the need for future research on social identity \
             and its influence on adult learning, particularly in \
             countries with existing deep-rooted hierarchical social constructs."
            
            published_1.arxiv_link="https://www.sciencedirect.com/science/article/pii/S0272775724000013";
            // wp2.doi="";
            // wp2.year=2022;
            published_1.authors_list= ["Sakshi Bhardwaj", "Abu S.Shonchoy"];
            // seams2022.bibtex='@inproceedings{ClelandHuang2022ExtendingMT,\
            //   title={Extending MAPE-K to support Human-Machine Teaming},\
            //   author={Jane Cleland-Huang and Ankit Agrawal and Michael Vierhauser and Michael Murphy and Mike Prieto},\
            //   year={2022}\
            // }'
            // seams2022.conference_name="17th Symposium on Software Engineering for Adaptive and Self-Managing Systems 2022",
            // seams2022.tags=[PaperTags.Human_Drone_Interaction, PaperTags.Visualization, PaperTags.Autonomous_Drone]
            published_1.type="Published and Accepted Papers"
            // wp2.ppt="",
            published_1.conference_url="https://www.sciencedirect.com/science/article/pii/S0272775724000013"
            // seams2022.has_award=false;
            // seams2022.award_name="";
            // seams2022.proj_id=Projects.Human_Drone
            published_1.isPublished=true;
            published_1.current_status="Economics of Education Review, 2024"
            publications.push(published_1);



      
            // let wip2 = new Publication()
            // wip2.title="Effect of Right to work (not mandating a worker to join a union) for Public Sector in the U.S";
            // wip2.abstract=""
            // // seams2022.arxiv_link="https://arxiv.org/pdf/2203.13036.pdf";
            // // wip1.doi="";
            // // wip1.year=2022;
            // wip2.authors_list= ["Sakshi Bhardwaj"];
            // // seams2022.bibtex='@inproceedings{ClelandHuang2022ExtendingMT,\
            // //   title={Extending MAPE-K to support Human-Machine Teaming},\
            // //   author={Jane Cleland-Huang and Ankit Agrawal and Michael Vierhauser and Michael Murphy and Mike Prieto},\
            // //   year={2022}\
            // // }'
            // // seams2022.conference_name="17th Symposium on Software Engineering for Adaptive and Self-Managing Systems 2022",
            // // seams2022.tags=[PaperTags.Human_Drone_Interaction, PaperTags.Visualization, PaperTags.Autonomous_Drone]
            // wip2.type="Work in Progress"
            // // wip1.ppt="",
            // // seams2022.conference_url="https://conf.researchr.org/home/seams-2022"
            // // seams2022.has_award=false;
            // // seams2022.award_name="";
            // // seams2022.proj_id=Projects.Human_Drone
            // wip2.isPublished=false;
            // publications.push(wip2);
        
        
            
        
        
         
        return publications;

    }


    getPublicationsByProjectId(id):Publication[]{
      let pubs =[]
      let all_pubs = this.get_all_publication()
      all_pubs.forEach(function(pub){
        if (pub.proj_id==id){
          pubs.push(pub)
        }
      })

      return pubs
        
    }
    
}
